export default __webpack_public_path__ + "static/media/atencion_rojo.51694121.svg";